<script>
import { mapActions, mapGetters } from 'vuex';
import { CUSTOMER_TYPES, CUSTOMER_SEX_TYPES, PAYMENT_TYPES } from '@/modules/constants';
import Coupon from '@/modules/invoice-summary/components/coupon/Coupon';

export default {
  name: 'InvoiceInformation',
  components: {
    Coupon
  },
  data() {
    return {
      CUSTOMER_TYPES,
      CUSTOMER_SEX_TYPES,
      PAYMENT_TYPES
    };
  },
  computed: {
    ...mapGetters(['invoiceData', 'formData', 'prices', 'customer'])
  },
  methods: {
    ...mapActions([
      'setInvoiceDataAction',
      'updateFormDataAction',
      'updateInvoiceDataAction',
      'updateFormErrorAction',
      'setIsFormDetailsEditAction',
      'setIsMobileAction'
    ])
  },
  mounted() {
    this.setIsMobileAction();
  }
};
</script>
<template>
  <div class="col-lg-5 col-md-6 col-sm-5 pl-0 pr-0">
    <div
      class="step3-left panel panel-default panel-hv-grey p-0"
      style="box-shadow: none; border: 1px solid rgb(221,221,221);"
    >
      <div class="panel-body" style="min-height: 1px">
        <strong> <i class="fa fa-edit"></i> Ihre Rechnungsdaten: </strong>
        <div id="kontakt_daten">
          <table class="width-100 mt-15">
            <tbody>
              <tr>
                <td style="width: 35%">Auftraggeber:</td>
                <td style="width: 65%">{{ invoiceData.customerType }}</td>
              </tr>

              <tr v-if="invoiceData.customerType === 'Firma'">
                <td>Firmenname:</td>
                <td>{{ invoiceData.firmName }}</td>
              </tr>

              <tr v-if="invoiceData.customerType === 'Firma' && invoiceData.firmBranch !== ''">
                <td>Branche:</td>
                <td>{{ invoiceData.firmBranch }}</td>
              </tr>

              <tr>
                <td style="width: 35%">Anrede:</td>
                <td style="width: 65%">{{ invoiceData.gender }}</td>
              </tr>

              <tr>
                <td>Vorname:</td>
                <td>{{ invoiceData.firstName }}</td>
              </tr>

              <tr>
                <td>Name:</td>
                <td>{{ invoiceData.lastName }}</td>
              </tr>

              <tr>
                <td>Adresse:</td>
                <td>
                  {{ invoiceData.strasse }}<br />
                  {{ invoiceData.zip }} {{ invoiceData.city }}
                </td>
              </tr>

              <tr>
                <td>Telefon:</td>
                <td>{{ invoiceData.phone }}</td>
              </tr>
              <tr>
                <td>Handy:</td>
                <td>{{ invoiceData.mobile }}</td>
              </tr>

              <tr>
                <td>E-Mail:</td>
                <td>{{ invoiceData.email }}</td>
              </tr>

              <tr v-if="invoiceData.birthDate">
                <td>Geburtsdatum:</td>
                <td>
                  {{ invoiceData.birthDate }}
                </td>
              </tr>

              <tr v-if="formData.paymentMethod">
                <td>Bezahlung:</td>
                <td>
                  {{ formData.paymentMethod }}
                </td>
              </tr>

              <tr v-if="invoiceData.note">
                <td>
                  Ihre Nachricht:
                </td>
                <td>{{ invoiceData.note }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <coupon v-if="!customer || (customer && !customer.bsr)" />
  </div>
</template>
<style lang="scss">
@import 'InvoiceInformationStyles';
</style>
